import { useMutation, useQueryClient } from 'react-query';
import queries from '../queries';

const useFacilityEdit = (callbacks = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ id, data }) => {
      return queries.facility.edit.query(id, data);
    },
    {
      ...callbacks,
      onSuccess: ({ data }, variables) => {
        queryClient.invalidateQueries(queries.facility.get.key);
        if (typeof callbacks.onSuccess === 'function') callbacks.onSuccess(data, variables);
      },
    }
  );
};

const useFacilityCreate = (callbacks = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    (data) => {
      return queries.facility.create.query(data);
    },
    {
      ...callbacks,
      onSuccess: ({ data }, variables) => {
        queryClient.invalidateQueries(queries.facility.get.key);
        if (typeof callbacks.onSuccess === 'function') callbacks.onSuccess(data, variables);
      },
    }
  );
};

export default {
  useFacilityCreate,
  useFacilityEdit,
};
